import { MessageBodyTextProps } from './types';

export const MessageBody = ({ children }: MessageBodyTextProps) => <>{children}</>;
